﻿import QRCodeStyling from "qr-code-styling";
import JSZip from "jszip";
import { hasDataPage, qs } from "../core/dom";
import Swiper from "swiper";
import { EffectCoverflow, Keyboard, Mousewheel, A11y } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-coverflow";

let qrInstance = null;
let logoDataUrl = "";
let bulkItems = [];

export function initQrGeneratorPage() {
    if (!hasDataPage("qr-generator")) return;

    const page = {
        mode: "single",
        type: "url",

        preview: qs("[data-qr-preview]"),
        status: qs("[data-qr-status]"),

        generateBtn: qs("[data-qr-generate]"),
        downloadBtn: qs("[data-qr-download]"),
        copySvgBtn: qs("[data-qr-copy-svg]"),
        loadExampleBtn: qs("[data-qr-load-example]"),
        resetBtn: qs("[data-qr-reset]"),

        modeTabs: Array.from(document.querySelectorAll("[data-qr-mode-tab]")),
        singleSettings: qs("[data-qr-single-settings]"),
        bulkSettings: qs("[data-qr-bulk-settings]"),

        typeCards: Array.from(document.querySelectorAll("[data-qr-type]")),
        typeSelect: qs("[data-qr-type-select]"),
        contentPanels: Array.from(document.querySelectorAll("[data-qr-content-panel]")),

        url: qs("[data-qr-url]"),
        text: qs("[data-qr-text]"),

        vFirstName: qs("[data-vcard-first-name]"),
        vLastName: qs("[data-vcard-last-name]"),
        vFullName: qs("[data-vcard-full-name]"),
        vCompany: qs("[data-vcard-company]"),
        vTitle: qs("[data-vcard-title]"),
        vPhone: qs("[data-vcard-phone]"),
        vEmail: qs("[data-vcard-email]"),
        vWebsite: qs("[data-vcard-website]"),
        vAddress: qs("[data-vcard-address]"),
        vStreet: qs("[data-vcard-street]"),
        vCity: qs("[data-vcard-city]"),
        vRegion: qs("[data-vcard-region]"),
        vPostal: qs("[data-vcard-postal]"),
        vCountry: qs("[data-vcard-country]"),
        vNote: qs("[data-vcard-note]"),
        whatsappNumber: qs("[data-whatsapp-number]"),
        whatsappMessage: qs("[data-whatsapp-message]"),

        locationLatitude: qs("[data-location-latitude]"),
        locationLongitude: qs("[data-location-longitude]"),
        locationLabel: qs("[data-location-label]"),
        locationType: qs("[data-location-type]"),

        eventTitle: qs("[data-event-title]"),
        eventLocation: qs("[data-event-location]"),
        eventStart: qs("[data-event-start]"),
        eventEnd: qs("[data-event-end]"),
        eventDescription: qs("[data-event-description]"),

        socialPlatform: qs("[data-social-platform]"),
        socialValue: qs("[data-social-value]"),

        appIosUrl: qs("[data-app-ios-url]"),
        appAndroidUrl: qs("[data-app-android-url]"),
        appFallbackUrl: qs("[data-app-fallback-url]"),

        paymentType: qs("[data-payment-type]"),
        paymentName: qs("[data-payment-name]"),
        paymentIban: qs("[data-payment-iban]"),
        paymentBic: qs("[data-payment-bic]"),
        paymentAmount: qs("[data-payment-amount]"),
        paymentCurrency: qs("[data-payment-currency]"),
        paymentDescription: qs("[data-payment-description]"),
        paymentLink: qs("[data-payment-link]"),

        cryptoNetwork: qs("[data-crypto-network]"),
        cryptoAddress: qs("[data-crypto-address]"),
        cryptoAmount: qs("[data-crypto-amount]"),
        cryptoLabel: qs("[data-crypto-label]"),
        cryptoMessage: qs("[data-crypto-message]"),

        fileUrl: qs("[data-file-url]"),
        fileTitle: qs("[data-file-title]"),

        menuRestaurant: qs("[data-menu-restaurant]"),
        menuTable: qs("[data-menu-table]"),
        menuUrl: qs("[data-menu-url]"),

        contactName: qs("[data-contact-name]"),
        contactCompany: qs("[data-contact-company]"),
        contactPhone: qs("[data-contact-phone]"),
        contactEmail: qs("[data-contact-email]"),
        contactWebsite: qs("[data-contact-website]"),

        meetingPlatform: qs("[data-meeting-platform]"),
        meetingUrl: qs("[data-meeting-url]"),
        meetingId: qs("[data-meeting-id]"),
        meetingPassword: qs("[data-meeting-password]"),

        wifiSsid: qs("[data-wifi-ssid]"),
        wifiPassword: qs("[data-wifi-password]"),
        wifiEncryption: qs("[data-wifi-encryption]"),
        wifiHidden: qs("[data-wifi-hidden]"),

        emailAddress: qs("[data-email-address]"),
        emailSubject: qs("[data-email-subject]"),
        emailBody: qs("[data-email-body]"),

        phoneNumber: qs("[data-phone-number]"),
        smsNumber: qs("[data-sms-number]"),
        smsMessage: qs("[data-sms-message]"),

        bulkInput: qs("[data-qr-bulk-input]"),
        bulkGenerateBtn: qs("[data-qr-generate-bulk]"),
        bulkDownloadBtn: qs("[data-qr-download-bulk]"),
        bulkResults: qs("[data-qr-bulk-results]"),
        bulkGrid: qs("[data-qr-bulk-grid]"),
        bulkCount: qs("[data-qr-bulk-count]"),

        dotStyle: qs("[data-qr-dot-style]"),
        cornerStyle: qs("[data-qr-corner-style]"),
        size: qs("[data-qr-size]"),
        errorCorrection: qs("[data-qr-error-correction]"),

        foreground: qs("[data-qr-foreground]"),
        background: qs("[data-qr-background]"),
        eyeOuter: qs("[data-qr-eye-outer-color]"),
        eyeInner: qs("[data-qr-eye-inner-color]"),
        transparent: qs("[data-qr-transparent]"),

        logo: qs("[data-qr-logo]"),
        logoSize: qs("[data-qr-logo-size]"),
        logoBackground: qs("[data-qr-logo-background]"),

        exportFormat: qs("[data-qr-export-format]"),
        fileName: qs("[data-qr-file-name]"),

        metaType: qs("[data-qr-meta-type]"),
        metaFormat: qs("[data-qr-meta-format]"),
        metaSize: qs("[data-qr-meta-size]"),
        presets: Array.from(document.querySelectorAll("[data-qr-preset]")),

        useGradient: qs("[data-qr-use-gradient]"),
        gradientSettings: qs("[data-qr-gradient-settings]"),
        gradientStart: qs("[data-qr-gradient-start]"),
        gradientEnd: qs("[data-qr-gradient-end]"),
        gradientType: qs("[data-qr-gradient-type]"),
        gradientRotation: qs("[data-qr-gradient-rotation]"),

        artboard: qs("[data-qr-artboard]"),
        showFrame: qs("[data-qr-show-frame]"),
        qrLabel: qs("[data-qr-label]"),
        qrLabelStyle: qs("[data-qr-label-style]"),
        previewLabel: qs("[data-qr-preview-label]"),

        qualityPanel: qs("[data-qr-quality-panel]"),
        qualityScore: qs("[data-qr-quality-score]"),
        qualityList: qs("[data-qr-quality-list]"),

        bulkCsv: qs("[data-qr-bulk-csv]"),

        designPresetCards: Array.from(document.querySelectorAll("[data-qr-design-preset]")),
        designMeta: qs("[data-qr-design-meta]"),

        dotStyleCards: Array.from(document.querySelectorAll("[data-qr-dot-style-card]")),
        dotStyleMeta: qs("[data-qr-dot-style-meta]"),

        cornerDotStyle: qs("[data-qr-corner-dot-style]"),

        eyeOuterCards: Array.from(document.querySelectorAll("[data-qr-eye-outer]")),
        eyeInnerCards: Array.from(document.querySelectorAll("[data-qr-eye-inner]")),
        eyeOuterMeta: qs("[data-qr-eye-outer-meta]"),
        eyeInnerMeta: qs("[data-qr-eye-inner-meta]"),

        // Eye advanced colors / gradients
        eyeOuterUseGradient: qs("[data-qr-eye-outer-use-gradient]"),
        eyeOuterGradientSettings: qs("[data-qr-eye-outer-gradient-settings]"),
        eyeOuterGradientStart: qs("[data-qr-eye-outer-gradient-start]"),
        eyeOuterGradientEnd: qs("[data-qr-eye-outer-gradient-end]"),
        eyeOuterGradientType: qs("[data-qr-eye-outer-gradient-type]"),
        eyeOuterGradientRotation: qs("[data-qr-eye-outer-gradient-rotation]"),

        eyeInnerUseGradient: qs("[data-qr-eye-inner-use-gradient]"),
        eyeInnerGradientSettings: qs("[data-qr-eye-inner-gradient-settings]"),
        eyeInnerGradientStart: qs("[data-qr-eye-inner-gradient-start]"),
        eyeInnerGradientEnd: qs("[data-qr-eye-inner-gradient-end]"),
        eyeInnerGradientType: qs("[data-qr-eye-inner-gradient-type]"),
        eyeInnerGradientRotation: qs("[data-qr-eye-inner-gradient-rotation]"),

        margin: qs("[data-qr-margin]"),
        logoMargin: qs("[data-qr-logo-margin]"),
        hideBackgroundDots: qs("[data-qr-hide-background-dots]"),

        selectedDotStyle: "dots",
        selectedOuterEyeType: "extra-rounded",
        selectedInnerEyeType: "extra-rounded",
        selectedDesignPreset: "custom",

        fileUpload: qs("[data-file-upload]"),
        qualityRing: qs("[data-qr-quality-ring]"),

        typeCarousel: qs("[data-qr-type-carousel]"),
        typeSwiperEl: qs("[data-qr-type-swiper]"),
        typeCarouselTitle: qs("[data-qr-type-carousel-title]"),
        typeCarouselDesc: qs("[data-qr-type-carousel-desc]"),
        typePrev: qs("[data-qr-type-prev]"),
        typeNext: qs("[data-qr-type-next]"),
    };

    bindQrEvents(page);

    syncQrDesignPresetCards(page, page.selectedDesignPreset);
    syncQrDotStyleCards(page, page.selectedDotStyle);
    syncQrEyeOuterCards(page, page.selectedOuterEyeType);
    syncQrEyeInnerCards(page, page.selectedInnerEyeType);

    if (page.typeSelect) {
        setQrType(page, page.typeSelect.value || "url");
    } else {
        setQrType(page, page.type || "url");
    }

    generateQr(page);
}

function bindQrEvents(page) {

    initQrTypeSwiper(page);

    page.typeCards.forEach(card => {
        card.addEventListener("click", () => {
            const type = card.dataset.qrType;
            setQrType(page, type);
        });
    });

    page.typeSelect?.addEventListener("change", () => {
        setQrType(page, page.typeSelect.value);
    });

    page.modeTabs.forEach(tab => {
        tab.addEventListener("click", () => {
            const mode = tab.dataset.qrModeTab;
            setQrMode(page, mode);
        });
    });

    page.designPresetCards.forEach(card => {
        card.addEventListener("click", event => {
            event.preventDefault();

            const preset = card.getAttribute("data-qr-design-preset");
            applyQrDesignPreset(page, preset);
        });
    });

    page.dotStyleCards.forEach(card => {
        card.addEventListener("click", () => {
            applyQrDotStyle(page, card.dataset.qrDotStyleCard);
        });
    });

    page.typeCards.forEach(card => {
        card.addEventListener("click", () => {
            const type = card.dataset.qrType;
            setQrType(page, type);
        });
    });

    if (page.typeSelect) {
        page.typeSelect.addEventListener("change", () => {
            setQrType(page, page.typeSelect.value);
        });

        if (window.jQuery) {
            window.jQuery(page.typeSelect).on("select2:select change", function () {
                setQrType(page, this.value);
            });
        }
    }

    page.fileUpload?.addEventListener("change", () => {
        const file = page.fileUpload.files?.[0];

        if (file && page.fileTitle && !page.fileTitle.value.trim()) {
            page.fileTitle.value = file.name.replace(/\.[^.]+$/, "");
        }
    });

    page.eyeOuterCards.forEach(card => {
        card.addEventListener("click", () => {
            applyQrEyeOuter(page, card.dataset.qrEyeOuter);
        });
    });

    page.eyeInnerCards.forEach(card => {
        card.addEventListener("click", () => {
            applyQrEyeInner(page, card.dataset.qrEyeInner);
        });
    });

    page.cornerStyle?.addEventListener("change", () => {
        syncQrEyeOuterCards(page, page.cornerStyle.value);
    });

    page.cornerDotStyle?.addEventListener("change", () => {
        syncQrEyeInnerCards(page, page.cornerDotStyle.value);
    });

    page.presets.forEach(btn => {
        btn.addEventListener("click", () => applyQrPreset(page, btn.dataset.qrPreset));
    });

    page.eyeOuterUseGradient?.addEventListener("change", () => {
        if (page.eyeOuterGradientSettings) {
            page.eyeOuterGradientSettings.hidden = !page.eyeOuterUseGradient.checked;
        }

        generateQr(page);
    });

    page.eyeInnerUseGradient?.addEventListener("change", () => {
        if (page.eyeInnerGradientSettings) {
            page.eyeInnerGradientSettings.hidden = !page.eyeInnerUseGradient.checked;
        }

        generateQr(page);
    });

    page.useGradient?.addEventListener("change", () => {
        if (page.gradientSettings) {
            page.gradientSettings.hidden = !page.useGradient.checked;
        }

        generateQr(page);
    });

    page.bulkCsv?.addEventListener("change", async () => {
        const file = page.bulkCsv.files?.[0];
        if (!file || !page.bulkInput) return;

        const text = await file.text();
        page.bulkInput.value = parseCsvFirstColumn(text).join("\n");
        setStatus(page, "CSV loaded", "is-valid");
    });

    const liveInputs = [
        page.url, page.text,
        page.vFirstName, page.vLastName, page.vFullName, page.vCompany, page.vTitle,
        page.vPhone, page.vEmail, page.vWebsite, page.vAddress,
        page.wifiSsid, page.wifiPassword, page.wifiEncryption, page.wifiHidden,
        page.emailAddress, page.emailSubject, page.emailBody,
        page.phoneNumber, page.smsNumber, page.smsMessage,
        page.dotStyle, page.cornerStyle, page.size, page.errorCorrection,
        page.foreground, page.background, page.eyeOuter, page.eyeInner, page.transparent,
        page.logoSize, page.logoBackground, page.exportFormat,
        page.useGradient,
        page.gradientStart,
        page.gradientEnd,
        page.gradientType,
        page.gradientRotation,
        page.showFrame,
        page.qrLabel,
        page.qrLabelStyle,
        page.vStreet,
        page.vCity,
        page.vRegion,
        page.vPostal,
        page.vCountry,
        page.vNote,
        page.cornerDotStyle,
        page.eyeOuterUseGradient,
        page.eyeOuterGradientStart,
        page.eyeOuterGradientEnd,
        page.eyeOuterGradientType,
        page.eyeOuterGradientRotation,

        page.eyeInnerUseGradient,
        page.eyeInnerGradientStart,
        page.eyeInnerGradientEnd,
        page.eyeInnerGradientType,
        page.eyeInnerGradientRotation,

        page.margin,
        page.logoMargin,
        page.hideBackgroundDots,

        page.whatsappNumber,
        page.whatsappMessage,

        page.locationLatitude,
        page.locationLongitude,
        page.locationLabel,
        page.locationType,

        page.eventTitle,
        page.eventLocation,
        page.eventStart,
        page.eventEnd,
        page.eventDescription,

        page.socialPlatform,
        page.socialValue,

        page.appIosUrl,
        page.appAndroidUrl,
        page.appFallbackUrl,

        page.paymentType,
        page.paymentName,
        page.paymentIban,
        page.paymentBic,
        page.paymentAmount,
        page.paymentCurrency,
        page.paymentDescription,
        page.paymentLink,

        page.cryptoNetwork,
        page.cryptoAddress,
        page.cryptoAmount,
        page.cryptoLabel,
        page.cryptoMessage,

        page.fileUrl,
        page.fileTitle,

        page.menuRestaurant,
        page.menuTable,
        page.menuUrl,

        page.contactName,
        page.contactCompany,
        page.contactPhone,
        page.contactEmail,
        page.contactWebsite,

        page.meetingPlatform,
        page.meetingUrl,
        page.meetingId,
        page.meetingPassword,
    ].filter(Boolean);

    liveInputs.forEach(input => {
        input.addEventListener("input", debounce(() => generateQr(page), 180));
        input.addEventListener("change", debounce(() => generateQr(page), 180));
        input.addEventListener("viwo:color-change", () => generateQr(page));
    });

    page.logo?.addEventListener("change", async () => {
        const file = page.logo.files?.[0];

        if (!file) {
            logoDataUrl = "";
            generateQr(page);
            return;
        }

        logoDataUrl = await readLogoAsDataUrl(file);
        generateQr(page);
    });

    page.generateBtn?.addEventListener("click", () => generateQr(page));
    page.downloadBtn?.addEventListener("click", () => downloadCurrentQr(page));
    page.copySvgBtn?.addEventListener("click", () => copyCurrentSvg(page));
    page.loadExampleBtn?.addEventListener("click", () => loadQrExample(page));
    page.resetBtn?.addEventListener("click", () => resetQr(page));

    page.bulkGenerateBtn?.addEventListener("click", () => generateBulk(page));
    page.bulkDownloadBtn?.addEventListener("click", () => downloadBulkZip(page));
}

function optimizeQrSvg(svgText) {
    if (!svgText || typeof svgText !== "string") return svgText;

    const parser = new DOMParser();
    const doc = parser.parseFromString(svgText, "image/svg+xml");

    const svg = doc.querySelector("svg");

    if (!svg) return svgText;

    const paths = Array.from(svg.querySelectorAll("path[d]"))
        .filter(path => !path.closest("defs"))
        .filter(path => !path.closest("clipPath"))
        .filter(path => !path.closest("mask"));

    const groups = new Map();

    paths.forEach(path => {
        const key = getSvgMergeKey(path);

        if (!groups.has(key)) {
            groups.set(key, []);
        }

        groups.get(key).push(path);
    });

    groups.forEach(group => {
        if (group.length < 2) return;

        const first = group[0];

        const mergedD = group
            .map(path => path.getAttribute("d"))
            .filter(Boolean)
            .join(" ");

        first.setAttribute("d", mergedD);

        for (let i = 1; i < group.length; i++) {
            group[i].remove();
        }
    });

    return new XMLSerializer().serializeToString(doc);
}

function getSvgMergeKey(path) {
    const attributes = [
        "fill",
        "stroke",
        "stroke-width",
        "stroke-linecap",
        "stroke-linejoin",
        "fill-rule",
        "clip-rule",
        "opacity",
        "transform",
        "clip-path",
        "mask"
    ];

    return attributes
        .map(attr => `${attr}:${path.getAttribute(attr) || ""}`)
        .join("|");
}

async function downloadOptimizedQrSvg(instance, fileName = "qr-code", page = null) {
    if (!instance) {
        console.warn("QR instance is not available.");
        return;
    }

    let svgText = null;

    if (typeof instance.getRawData === "function") {
        const raw = await instance.getRawData("svg");

        if (raw instanceof Blob) {
            svgText = await raw.text();
        } else if (typeof raw === "string") {
            svgText = raw;
        }
    }

    if (!svgText) {
        svgText = getSvgTextFromQrPreview();
    }

    if (!svgText || !svgText.trim().startsWith("<")) {
        console.warn("QR SVG export is empty or invalid.", svgText);
        return;
    }

    const optimizedSvg = rebuildQrInnerEyes(svgText, instance, page);

    if (!optimizedSvg || !optimizedSvg.trim().startsWith("<svg")) {
        console.warn("Optimized SVG is invalid.", optimizedSvg);
        return;
    }

    downloadTextFile(
        optimizedSvg,
        `${fileName}.svg`,
        "image/svg+xml;charset=utf-8"
    );
}

function getSvgTextFromQrPreview() {
    const preview =
        document.querySelector("[data-qr-code]") ||
        document.querySelector("[data-qr-preview]") ||
        document.querySelector(".qr-preview") ||
        document.querySelector(".qr-preview-frame");

    const svg = preview?.querySelector("svg");

    if (!svg) return null;

    return new XMLSerializer().serializeToString(svg);
}

function rebuildQrInnerEyes(svgText, instance, page) {
    if (!svgText || typeof svgText !== "string") return svgText;

    const parser = new DOMParser();
    const doc = parser.parseFromString(svgText, "image/svg+xml");

    const parserError = doc.querySelector("parsererror");

    if (parserError) {
        console.warn("SVG parse error:", parserError.textContent);
        return svgText;
    }

    const svg = doc.documentElement;

    if (!svg || svg.nodeName.toLowerCase() !== "svg") {
        return svgText;
    }

    const svgSize = getSvgSize(svg);
    const measured = measureSvgShapes(svg);

    if (!measured.length) {
        return svgText;
    }

    const eyeFixes = detectInnerEyeFixes(measured, svgSize);

    if (!eyeFixes.length) {
        console.warn("QR inner eyes could not be detected.");
        return svgText;
    }

    const fallbackColor =
        instance?._options?.cornersDotOptions?.color ||
        instance?._options?.dotsOptions?.color ||
        "#000000";

    const innerEyeType = getCurrentQrEyeDotType(page, instance);

    eyeFixes.forEach(fix => {
        const color = fix.color || fallbackColor;

        fix.nodes.forEach(node => {
            node.remove();
        });

        const newNode = createInnerEyeShapeFromBox(
            doc,
            fix.box,
            innerEyeType,
            color
        );

        if (newNode) {
            svg.appendChild(newNode);
        }
    });

    return new XMLSerializer().serializeToString(svg);
}

function getCurrentQrEyeDotType(page, instance) {
    const root =
        page?.root ||
        page?.page ||
        document;

    const activeCard =
        root.querySelector?.(".qr-eye-card.active[data-qr-eye-inner]") ||
        root.querySelector?.("[data-qr-eye-inner].active") ||
        document.querySelector(".qr-eye-card.active[data-qr-eye-inner]") ||
        document.querySelector("[data-qr-eye-inner].active");

    const select =
        root.querySelector?.("[data-qr-eye-inner-select]") ||
        root.querySelector?.("[data-qr-eye-dot-select]") ||
        document.querySelector("[data-qr-eye-inner-select]") ||
        document.querySelector("[data-qr-eye-dot-select]");

    const value =
        activeCard?.dataset?.qrEyeInner ||
        activeCard?.dataset?.qrEyeDot ||
        select?.value ||
        page?.eyeInnerType ||
        page?.eyeDotType ||
        page?.currentOptions?.cornersDotOptions?.type ||
        page?.qrOptions?.cornersDotOptions?.type ||
        instance?._options?.cornersDotOptions?.type ||
        "extra-rounded";

    return normalizeInnerEyeType(value);
}

function createInnerEyeShapeFromBox(doc, box, type, color) {
    const x = box.x;
    const y = box.y;
    const width = box.width;
    const height = box.height;
    const size = Math.min(width, height);

    if (type === "dot") {
        const ellipse = doc.createElementNS("http://www.w3.org/2000/svg", "ellipse");

        ellipse.setAttribute("cx", String(x + width / 2));
        ellipse.setAttribute("cy", String(y + height / 2));
        ellipse.setAttribute("rx", String(width / 2));
        ellipse.setAttribute("ry", String(height / 2));
        ellipse.setAttribute("fill", color);
        ellipse.setAttribute("shape-rendering", "geometricPrecision");

        return ellipse;
    }

    if (type === "dots") {
        return createInnerEyeDotsGridFromBox(doc, box, color);
    }

    if (type === "classy") {
        return createClassyInnerEyePath(doc, box, color);
    }

    if (type === "classy-rounded") {
        return createClassyRoundedInnerEyePath(doc, box, color);
    }

    const rect = doc.createElementNS("http://www.w3.org/2000/svg", "rect");

    rect.setAttribute("x", String(x));
    rect.setAttribute("y", String(y));
    rect.setAttribute("width", String(width));
    rect.setAttribute("height", String(height));
    rect.setAttribute("fill", color);
    rect.setAttribute("shape-rendering", "geometricPrecision");

    let rx = 0;

    switch (type) {
        case "square":
            rx = 0;
            break;

        case "rounded":
            rx = size * 0.22;
            break;

        case "extra-rounded":
            rx = size * 0.34;
            break;

        default:
            rx = size * 0.34;
            break;
    }

    rect.setAttribute("rx", String(rx));
    rect.setAttribute("ry", String(rx));

    return rect;
}

function createClassyInnerEyePath(doc, box, color) {
    const x = box.x;
    const y = box.y;
    const w = box.width;
    const h = box.height;
    const r = Math.min(w, h) * 0.34;

    // Classy: top-left ve bottom-right yumuşak,
    // top-right ve bottom-left daha keskin.
    const d = [
        `M ${x + r} ${y}`,
        `H ${x + w}`,
        `V ${y + h - r}`,
        `Q ${x + w} ${y + h} ${x + w - r} ${y + h}`,
        `H ${x}`,
        `V ${y + r}`,
        `Q ${x} ${y} ${x + r} ${y}`,
        "Z"
    ].join(" ");

    const path = doc.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", d);
    path.setAttribute("fill", color);
    path.setAttribute("shape-rendering", "geometricPrecision");

    return path;
}

function createClassyRoundedInnerEyePath(doc, box, color) {
    const x = box.x;
    const y = box.y;
    const w = box.width;
    const h = box.height;

    const bigR = Math.min(w, h) * 0.38;
    const smallR = Math.min(w, h) * 0.18;

    // Classy-rounded: tüm yapı daha akıcı,
    // karşılıklı köşeler daha büyük radius alır.
    const d = [
        `M ${x + bigR} ${y}`,
        `H ${x + w - smallR}`,
        `Q ${x + w} ${y} ${x + w} ${y + smallR}`,
        `V ${y + h - bigR}`,
        `Q ${x + w} ${y + h} ${x + w - bigR} ${y + h}`,
        `H ${x + smallR}`,
        `Q ${x} ${y + h} ${x} ${y + h - smallR}`,
        `V ${y + bigR}`,
        `Q ${x} ${y} ${x + bigR} ${y}`,
        "Z"
    ].join(" ");

    const path = doc.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", d);
    path.setAttribute("fill", color);
    path.setAttribute("shape-rendering", "geometricPrecision");

    return path;
}

function createInnerEyeDotsGridFromBox(doc, box, color) {
    const group = doc.createElementNS("http://www.w3.org/2000/svg", "g");

    const stepX = box.width / 3;
    const stepY = box.height / 3;

    const dotWidth = stepX * 0.72;
    const dotHeight = stepY * 0.72;

    const offsetX = (stepX - dotWidth) / 2;
    const offsetY = (stepY - dotHeight) / 2;

    const radius = Math.min(dotWidth, dotHeight) / 2;

    for (let row = 0; row < 3; row++) {
        for (let col = 0; col < 3; col++) {
            const rect = doc.createElementNS("http://www.w3.org/2000/svg", "rect");

            rect.setAttribute("x", String(box.x + col * stepX + offsetX));
            rect.setAttribute("y", String(box.y + row * stepY + offsetY));
            rect.setAttribute("width", String(dotWidth));
            rect.setAttribute("height", String(dotHeight));
            rect.setAttribute("rx", String(radius));
            rect.setAttribute("ry", String(radius));
            rect.setAttribute("fill", color);

            group.appendChild(rect);
        }
    }

    return group;
}

function detectInnerEyeFixes(measured, svgSize) {
    const { width, height } = svgSize;

    const corners = [
        {
            name: "top-left",
            filter: item => item.centerX < width / 2 && item.centerY < height / 2
        },
        {
            name: "top-right",
            filter: item => item.centerX > width / 2 && item.centerY < height / 2
        },
        {
            name: "bottom-left",
            filter: item => item.centerX < width / 2 && item.centerY > height / 2
        }
    ];

    const fixes = [];

    corners.forEach(corner => {
        const cornerItems = measured.filter(corner.filter);

        if (!cornerItems.length) return;

        const outerEye = findOuterEyeCandidate(cornerItems);

        if (!outerEye) return;

        const target = getInnerEyeApproxBoxFromOuterEye(outerEye.box);

        const innerPieces = cornerItems.filter(item => {
            if (item.node === outerEye.node) return false;

            const itemBox = item.box;

            const itemCenterInside =
                item.centerX >= target.x &&
                item.centerX <= target.x + target.width &&
                item.centerY >= target.y &&
                item.centerY <= target.y + target.height;

            const itemMostlyInside = boxMostlyInside(itemBox, target, 0.55);

            const notTooLarge =
                item.area <= target.width * target.height * 1.6;

            return (itemCenterInside || itemMostlyInside) && notTooLarge;
        });

        if (!innerPieces.length) return;

        const unionBox = unionBoxes(innerPieces.map(x => x.box));

        const color =
            getMostCommonFill(innerPieces) ||
            innerPieces[0]?.fill ||
            "#000000";

        fixes.push({
            corner: corner.name,
            box: unionBox,
            color,
            nodes: innerPieces.map(x => x.node)
        });
    });

    return fixes;
}

function findOuterEyeCandidate(items) {
    const sorted = [...items]
        .filter(item => item.area > 0)
        .sort((a, b) => b.area - a.area);

    // En büyük obje genelde outer eye frame oluyor.
    // Background rect varsa quadrant merkezinde kalmadığı için zaten gelmez.
    return sorted[0] || null;
}

function getInnerEyeApproxBoxFromOuterEye(outerBox) {
    const size = Math.min(outerBox.width, outerBox.height);
    const innerSize = size * 3 / 7;

    return {
        x: outerBox.x + (outerBox.width - innerSize) / 2,
        y: outerBox.y + (outerBox.height - innerSize) / 2,
        width: innerSize,
        height: innerSize
    };
}

function boxMostlyInside(box, target, threshold = 0.55) {
    const ix = Math.max(box.x, target.x);
    const iy = Math.max(box.y, target.y);
    const ax = Math.min(box.x + box.width, target.x + target.width);
    const ay = Math.min(box.y + box.height, target.y + target.height);

    const intersectionWidth = Math.max(0, ax - ix);
    const intersectionHeight = Math.max(0, ay - iy);
    const intersectionArea = intersectionWidth * intersectionHeight;

    const boxArea = box.width * box.height;

    if (boxArea <= 0) return false;

    return intersectionArea / boxArea >= threshold;
}

function unionBoxes(boxes) {
    const x1 = Math.min(...boxes.map(box => box.x));
    const y1 = Math.min(...boxes.map(box => box.y));
    const x2 = Math.max(...boxes.map(box => box.x + box.width));
    const y2 = Math.max(...boxes.map(box => box.y + box.height));

    return {
        x: x1,
        y: y1,
        width: x2 - x1,
        height: y2 - y1
    };
}

function getMostCommonFill(items) {
    const counts = new Map();

    items.forEach(item => {
        if (!item.fill) return;

        counts.set(item.fill, (counts.get(item.fill) || 0) + 1);
    });

    let best = null;
    let bestCount = 0;

    counts.forEach((count, fill) => {
        if (count > bestCount) {
            best = fill;
            bestCount = count;
        }
    });

    return best;
}

function getSvgSize(svg) {
    const viewBox = String(svg.getAttribute("viewBox") || "")
        .trim()
        .split(/\s+/)
        .map(Number);

    const width =
        Number(svg.getAttribute("width")) ||
        viewBox[2] ||
        512;

    const height =
        Number(svg.getAttribute("height")) ||
        viewBox[3] ||
        512;

    return {
        width,
        height
    };
}

function measureSvgShapes(svg) {
    const originalNodes = Array.from(
        svg.querySelectorAll("path, rect, circle, ellipse, polygon, polyline")
    ).filter(node => {
        if (node.closest("defs, clipPath, mask")) return false;
        return true;
    });

    if (!originalNodes.length) return [];

    const cloneSvg = svg.cloneNode(true);

    const cloneNodes = Array.from(
        cloneSvg.querySelectorAll("path, rect, circle, ellipse, polygon, polyline")
    ).filter(node => {
        if (node.closest("defs, clipPath, mask")) return false;
        return true;
    });

    const host = document.createElement("div");

    host.style.position = "fixed";
    host.style.left = "-100000px";
    host.style.top = "-100000px";
    host.style.width = "0";
    host.style.height = "0";
    host.style.opacity = "0";
    host.style.pointerEvents = "none";

    document.body.appendChild(host);
    host.appendChild(cloneSvg);

    const result = [];

    try {
        cloneNodes.forEach((cloneNode, index) => {
            let box;

            try {
                box = cloneNode.getBBox();
            } catch {
                return;
            }

            if (!box || box.width <= 0 || box.height <= 0) return;

            const originalNode = originalNodes[index];

            if (!originalNode) return;

            result.push({
                node: originalNode,
                box: {
                    x: box.x,
                    y: box.y,
                    width: box.width,
                    height: box.height
                },
                area: box.width * box.height,
                centerX: box.x + box.width / 2,
                centerY: box.y + box.height / 2,
                fill: getSvgNodeFill(originalNode)
            });
        });
    } finally {
        host.remove();
    }

    return result;
}

function getSvgNodeFill(node) {
    const directFill = node.getAttribute("fill");

    if (directFill && directFill !== "none") {
        return directFill;
    }

    const style = node.getAttribute("style") || "";
    const match = style.match(/fill\s*:\s*([^;]+)/i);

    if (match?.[1]) {
        return match[1].trim();
    }

    return null;
}

function removeShapesInsideZonesUsingClone(svg, zones) {
    const originalCandidates = Array.from(
        svg.querySelectorAll("path, rect, circle, ellipse, polygon, polyline")
    ).filter(node => {
        if (node.closest("defs, clipPath, mask")) return false;
        return true;
    });

    if (!originalCandidates.length) return;

    const cloneSvg = svg.cloneNode(true);

    const cloneCandidates = Array.from(
        cloneSvg.querySelectorAll("path, rect, circle, ellipse, polygon, polyline")
    ).filter(node => {
        if (node.closest("defs, clipPath, mask")) return false;
        return true;
    });

    const host = document.createElement("div");

    host.style.position = "fixed";
    host.style.left = "-100000px";
    host.style.top = "-100000px";
    host.style.width = "0";
    host.style.height = "0";
    host.style.opacity = "0";
    host.style.pointerEvents = "none";

    document.body.appendChild(host);
    host.appendChild(cloneSvg);

    const removeIndexes = [];

    try {
        cloneCandidates.forEach((node, index) => {
            let box;

            try {
                box = node.getBBox();
            } catch {
                return;
            }

            if (!box || box.width <= 0 || box.height <= 0) return;

            const contained = zones.some(zone =>
                box.x >= zone.x - 0.75 &&
                box.y >= zone.y - 0.75 &&
                box.x + box.width <= zone.x + zone.size + 0.75 &&
                box.y + box.height <= zone.y + zone.size + 0.75
            );

            if (contained) {
                removeIndexes.push(index);
            }
        });
    } finally {
        host.remove();
    }

    removeIndexes
        .sort((a, b) => b - a)
        .forEach(index => {
            originalCandidates[index]?.remove();
        });
}

function createInnerEyeShape(doc, zone, type, color) {
    const { x, y, size } = zone;

    if (type === "dot") {
        const circle = doc.createElementNS("http://www.w3.org/2000/svg", "circle");
        circle.setAttribute("cx", String(x + size / 2));
        circle.setAttribute("cy", String(y + size / 2));
        circle.setAttribute("r", String(size / 2));
        circle.setAttribute("fill", color);
        return circle;
    }

    if (type === "dots") {
        return createInnerEyeDotsGrid(doc, x, y, size, color);
    }

    const rect = doc.createElementNS("http://www.w3.org/2000/svg", "rect");
    rect.setAttribute("x", String(x));
    rect.setAttribute("y", String(y));
    rect.setAttribute("width", String(size));
    rect.setAttribute("height", String(size));
    rect.setAttribute("fill", color);

    let rx = 0;

    switch (type) {
        case "square":
            rx = 0;
            break;

        case "rounded":
            rx = size * 0.22;
            break;

        case "extra-rounded":
            rx = size * 0.34;
            break;

        case "classy":
            rx = size * 0.18;
            break;

        case "classy-rounded":
            rx = size * 0.28;
            break;

        default:
            rx = size * 0.34;
            break;
    }

    rect.setAttribute("rx", String(rx));
    rect.setAttribute("ry", String(rx));

    return rect;
}

function createInnerEyeDotsGrid(doc, x, y, size, color) {
    const group = doc.createElementNS("http://www.w3.org/2000/svg", "g");

    const step = size / 3;
    const dotSize = step * 0.72;
    const offset = (step - dotSize) / 2;
    const radius = dotSize / 2;

    for (let row = 0; row < 3; row++) {
        for (let col = 0; col < 3; col++) {
            const rect = doc.createElementNS("http://www.w3.org/2000/svg", "rect");
            rect.setAttribute("x", String(x + col * step + offset));
            rect.setAttribute("y", String(y + row * step + offset));
            rect.setAttribute("width", String(dotSize));
            rect.setAttribute("height", String(dotSize));
            rect.setAttribute("rx", String(radius));
            rect.setAttribute("ry", String(radius));
            rect.setAttribute("fill", color);
            group.appendChild(rect);
        }
    }

    return group;
}





function getQrSvgMeta(instance, svg) {
    const width =
        Number(instance?._options?.width) ||
        Number(svg.getAttribute("width")) ||
        Number(svg.getAttribute("viewBox")?.split(/\s+/)[2]) ||
        512;

    const height =
        Number(instance?._options?.height) ||
        Number(svg.getAttribute("height")) ||
        Number(svg.getAttribute("viewBox")?.split(/\s+/)[3]) ||
        512;

    const margin =
        Number(instance?._options?.margin) ||
        0;

    const moduleCount =
        instance?._qr?._moduleCount ||
        instance?._qr?.getModuleCount?.() ||
        instance?._oQRCode?._moduleCount ||
        guessQrModuleCountFromSvg(width, margin);

    if (!moduleCount || moduleCount <= 0) return null;

    const moduleSize = (width - margin * 2) / moduleCount;

    const innerEyeType =
        normalizeInnerEyeType(
            instance?._options?.cornersDotOptions?.type || "extra-rounded"
        );

    const innerEyeColor =
        instance?._options?.cornersDotOptions?.color ||
        instance?._options?.dotsOptions?.color ||
        "#000000";

    return {
        width,
        height,
        margin,
        moduleCount,
        moduleSize,
        innerEyeType,
        innerEyeColor
    };
}

function guessQrModuleCountFromSvg(width, margin) {
    // QR Code minimum version 1 = 21 modules.
    // Eğer instance private moduleCount dönmezse en güvenli fallback bu.
    // Çoğu kısa URL için 21 doğru olur.
    return 21;
}

function downloadTextFile(content, fileName, mimeType) {
    if (!content || typeof content !== "string") {
        console.warn("Download content is empty.");
        return;
    }

    const blob = new Blob([content], {
        type: mimeType
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    link.remove();

    URL.revokeObjectURL(url);
}

function initQrTypeSwiper(page) {
    if (!page.typeSwiperEl) return;
    if (page.typeSwiperEl.swiper) return;

    const slides = Array.from(page.typeSwiperEl.querySelectorAll("[data-qr-type-slide]"));

    const swiper = new Swiper(page.typeSwiperEl, {
        modules: [EffectCoverflow, Keyboard, Mousewheel, A11y],
        effect: "coverflow",
        loop: slides.length > 5,
        centeredSlides: true,
        slidesPerView: "auto",

        initialSlide: Math.max(
            0,
            slides.findIndex(x => x.dataset.qrTypeSlide === (page.type || "url"))
        ),

        speed: 760,
        grabCursor: true,
        resistanceRatio: 0.72,
        threshold: 4,
        longSwipesRatio: 0.18,
        longSwipesMs: 180,
        followFinger: true,
        watchSlidesProgress: true,

        keyboard: {
            enabled: true,
            onlyInViewport: true
        },

        mousewheel: {
            forceToAxis: true,
            sensitivity: 0.42,
            thresholdDelta: 18,
            thresholdTime: 180
        },

        coverflowEffect: {
            rotate: 0,
            stretch: 6,
            depth: 105,
            modifier: 1.45,
            scale: 0.92,
            slideShadows: false
        },

        a11y: {
            enabled: true,
            slideLabelMessage: "{{index}} / {{slidesLength}}"
        },

        on: {
            init(swiperInstance) {
                swiperInstance.el.classList.add("is-ready");
                syncQrTypeFromSwiper(page, swiperInstance);
            },

            transitionStart(swiperInstance) {
                swiperInstance.el.classList.add("is-moving");
            },

            transitionEnd(swiperInstance) {
                swiperInstance.el.classList.remove("is-moving");
            },

            touchStart(swiperInstance) {
                swiperInstance.el.classList.add("is-dragging");
            },

            touchEnd(swiperInstance) {
                swiperInstance.el.classList.remove("is-dragging");
            },

            slideChange(swiperInstance) {
                syncQrTypeFromSwiper(page, swiperInstance);
            }
        }
    });

    page.typePrev?.addEventListener("click", () => {
        swiper.slidePrev();
    });

    page.typeNext?.addEventListener("click", () => {
        swiper.slideNext();
    });

    slides.forEach(slide => {
        slide.addEventListener("click", () => {
            const realIndex = Number(slide.dataset.swiperSlideIndex ?? slides.indexOf(slide));

            if (swiper.params.loop) {
                swiper.slideToLoop(realIndex, 760);
                return;
            }

            swiper.slideTo(slides.indexOf(slide), 760);
        });
    });

    page.typeSwiper = swiper;
}

let qrPanelTransitionId = 0;

function activateQrContentPanel(page, type) {
    const selectedType = String(type || "url").trim().toLowerCase();
    const panels = page.contentPanels || [];

    qrPanelTransitionId++;

    const transitionId = qrPanelTransitionId;
    const currentPanel = panels.find(panel => panel.classList.contains("active") && !panel.hidden);
    const nextPanel = panels.find(panel => {
        const panelType = String(panel.dataset.qrContentPanel || "").trim().toLowerCase();
        return panelType === selectedType;
    });

    if (!nextPanel) return;

    if (currentPanel === nextPanel) {
        nextPanel.hidden = false;
        nextPanel.classList.add("active");
        return;
    }

    panels.forEach(panel => {
        panel.classList.remove("is-entering", "is-leaving");
    });

    if (currentPanel) {
        currentPanel.classList.add("is-leaving");
        currentPanel.classList.remove("active");

        window.setTimeout(() => {
            if (transitionId !== qrPanelTransitionId) return;

            currentPanel.hidden = true;
            currentPanel.classList.remove("is-leaving");
        }, 220);
    }

    nextPanel.hidden = false;
    nextPanel.classList.add("active", "is-entering");

    window.setTimeout(() => {
        if (transitionId !== qrPanelTransitionId) return;

        nextPanel.classList.remove("is-entering");
    }, 460);

    panels.forEach(panel => {
        if (panel !== currentPanel && panel !== nextPanel) {
            panel.hidden = true;
            panel.classList.remove("active", "is-entering", "is-leaving");
        }
    });
}

function syncQrTypeFromSwiper(page, swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];

    if (!activeSlide) return;

    const type = activeSlide.dataset.qrTypeSlide;
    const title = activeSlide.dataset.title || type;
    const description = activeSlide.dataset.description || "";

    if (!type) return;

    page.type = type;

    if (page.typeSelect && page.typeSelect.value !== type) {
        page.typeSelect.value = type;
    }

    if (page.typeCarouselTitle) {
        page.typeCarouselTitle.textContent = title;
    }

    if (page.typeCarouselDesc) {
        page.typeCarouselDesc.textContent = description;
    }

    /*
    page.contentPanels.forEach(panel => {
        const isActive = panel.dataset.qrContentPanel === type;
        panel.hidden = !isActive;
        panel.classList.toggle("active", isActive);
    });*/

    activateQrContentPanel(page, type);

    generateQr(page);
}

function syncQrDesignPresetCards(page, value) {
    const normalized = normalizeDesignPreset(value);

    page.selectedDesignPreset = normalized;

    page.designPresetCards?.forEach(card => {
        card.classList.toggle(
            "active",
            normalized !== "custom" &&
            normalizeDesignPreset(card.dataset.qrDesignPreset) === normalized
        );
    });

    if (page.designMeta) {
        page.designMeta.textContent = getDesignPresetLabel(normalized);
    }
}

function syncQrDesignPresetCardsV1(page, value) {
    const normalized = normalizeDesignPreset(value);

    page.designPresetCards?.forEach(card => {
        card.classList.toggle(
            "active",
            normalizeDesignPreset(card.dataset.qrDesignPreset) === normalized
        );
    });

    if (page.designMeta) {
        page.designMeta.textContent = getDesignPresetLabel(normalized);
    }
}

function normalizeDesignPreset(value) {
    const preset = String(value || "rounded").toLowerCase();

    const allowed = [
        "square",
        "rounded",
        "dots",
        "extra-rounded",
        "classy",
        "classy-rounded",
        "brand",
        "bold",
        "custom"
    ];

    return allowed.includes(preset) ? preset : "rounded";
}

function getDesignPresetLabel(value) {
    switch (normalizeDesignPreset(value)) {
        case "custom":
            return "Custom";

        case "square":
            return "Square";

        case "dots":
            return "Dots";

        case "extra-rounded":
            return "Extra Rounded";

        case "classy":
            return "Classy";

        case "classy-rounded":
            return "Classy Rounded";

        case "brand":
            return "Brand";

        case "bold":
            return "Bold";

        case "rounded":
        default:
            return "Rounded";
    }
}

function applyQrEyeOuter(page, type) {
    const value = normalizeOuterEyeType(type);

    page.selectedOuterEyeType = value;
    page.selectedDesignPreset = "custom";

    syncQrDesignPresetCards(page, "custom");
    syncQrEyeOuterCards(page, value);
    generateQr(page);
}

function applyQrEyeInner(page, type) {
    const value = normalizeInnerEyeType(type);

    page.selectedInnerEyeType = value;
    page.selectedDesignPreset = "custom";

    syncQrDesignPresetCards(page, "custom");
    syncQrEyeInnerCards(page, value);
    generateQr(page);
}

function syncQrEyeOuterCards(page, value) {
    const normalized = normalizeOuterEyeType(value);

    page.eyeOuterCards?.forEach(card => {
        card.classList.toggle(
            "active",
            normalizeOuterEyeType(card.dataset.qrEyeOuter) === normalized
        );
    });

    if (page.eyeOuterMeta) {
        page.eyeOuterMeta.textContent = getOuterEyeLabel(normalized);
    }
}

function buildGradientOptions(typeInput, rotationInput, startInput, endInput) {
    return {
        type: typeInput?.value || "linear",
        rotation: ((Number(rotationInput?.value || 45)) * Math.PI) / 180,
        colorStops: [
            { offset: 0, color: startInput?.value || "#6366f1" },
            { offset: 1, color: endInput?.value || "#22c55e" }
        ]
    };
}

function syncQrEyeInnerCards(page, value) {
    const normalized = normalizeInnerEyeType(value);

    page.eyeInnerCards?.forEach(card => {
        card.classList.toggle("active", normalizeInnerEyeType(card.dataset.qrEyeInner) === normalized);
    });

    if (page.eyeInnerMeta) {
        page.eyeInnerMeta.textContent = getInnerEyeLabel(normalized);
    }
}

function normalizeOuterEyeType(value) {
    const type = String(value || "extra-rounded").toLowerCase();

    const allowed = [
        "dot",
        "square",
        "extra-rounded",
        "rounded",
        "dots",
        "classy",
        "classy-rounded"
    ];

    return allowed.includes(type) ? type : "extra-rounded";
}

function normalizeInnerEyeType(value) {
    const type = String(value || "square").toLowerCase();

    const allowed = [
        "dot",
        "square",
        "rounded",
        "dots",
        "classy",
        "classy-rounded",
        "extra-rounded"
    ];

    return allowed.includes(type) ? type : "square";
}

function applyQrDotStyle(page, type) {
    const value = normalizeDotStyle(type);

    page.selectedDotStyle = value;
    page.selectedDesignPreset = "custom";

    syncQrDesignPresetCards(page, "custom");
    syncQrDotStyleCards(page, value);
    generateQr(page);
}

function syncQrDotStyleCards(page, value) {
    const normalized = normalizeDotStyle(value);

    page.dotStyleCards?.forEach(card => {
        card.classList.toggle(
            "active",
            normalizeDotStyle(card.dataset.qrDotStyleCard) === normalized
        );
    });

    if (page.dotStyleMeta) {
        page.dotStyleMeta.textContent = getDotStyleLabel(normalized);
    }
}

function getDotStyleLabel(value) {
    switch (normalizeDotStyle(value)) {
        case "square":
            return "Square";

        case "dots":
            return "Dots";

        case "extra-rounded":
            return "Extra Rounded";

        case "classy":
            return "Classy";

        case "classy-rounded":
            return "Classy Rounded";

        case "rounded":
        default:
            return "Rounded";
    }
}

function getOuterEyeLabel(value) {
    switch (normalizeOuterEyeType(value)) {
        case "dot":
            return "Dot";

        case "square":
            return "Square";

        case "rounded":
            return "Rounded";

        case "dots":
            return "Dots";

        case "classy":
            return "Classy";

        case "classy-rounded":
            return "Classy Rounded";

        case "extra-rounded":
        default:
            return "Extra Rounded";
    }
}

function getInnerEyeLabel(value) {
    switch (normalizeInnerEyeType(value)) {
        case "dot":
            return "Dot";

        case "rounded":
            return "Rounded";

        case "dots":
            return "Dots";

        case "classy":
            return "Classy";

        case "classy-rounded":
            return "Classy Rounded";

        case "extra-rounded":
            return "Extra Rounded";

        case "square":
        default:
            return "Square";
    }
}

function applyQrDesignPreset(page, preset) {
    const presetKey = normalizeDesignPreset(preset);

    const presets = {
        "square": {
            label: "Square",
            dotStyle: "square",
            cornerStyle: "square",
            cornerDotStyle: "square",
            errorCorrection: "M"
        },
        "rounded": {
            label: "Rounded",
            dotStyle: "rounded",
            cornerStyle: "rounded",
            cornerDotStyle: "rounded",
            errorCorrection: "Q"
        },
        "dots": {
            label: "Dots",
            dotStyle: "dots",
            cornerStyle: "dots",
            cornerDotStyle: "dots",
            errorCorrection: "Q"
        },
        "extra-rounded": {
            label: "Extra Rounded",
            dotStyle: "extra-rounded",
            cornerStyle: "extra-rounded",
            cornerDotStyle: "extra-rounded",
            errorCorrection: "Q"
        },
        "classy": {
            label: "Classy",
            dotStyle: "classy",
            cornerStyle: "classy",
            cornerDotStyle: "classy",
            errorCorrection: "Q"
        },
        "classy-rounded": {
            label: "Classy Rounded",
            dotStyle: "classy-rounded",
            cornerStyle: "classy-rounded",
            cornerDotStyle: "classy-rounded",
            errorCorrection: "Q"
        },
        "brand": {
            label: "Brand",
            dotStyle: "classy-rounded",
            cornerStyle: "extra-rounded",
            cornerDotStyle: "extra-rounded",
            errorCorrection: "H"
        },
        "bold": {
            label: "Bold",
            dotStyle: "square",
            cornerStyle: "square",
            cornerDotStyle: "square",
            errorCorrection: "H"
        }
    };

    const selected = presets[presetKey] || presets.rounded;

    page.selectedDesignPreset = presetKey;
    page.selectedDotStyle = normalizeDotStyle(selected.dotStyle);
    page.selectedOuterEyeType = normalizeOuterEyeType(selected.cornerStyle);
    page.selectedInnerEyeType = normalizeInnerEyeType(selected.cornerDotStyle);

    syncQrDesignPresetCards(page, presetKey);
    syncQrDotStyleCards(page, page.selectedDotStyle);
    syncQrEyeOuterCards(page, page.selectedOuterEyeType);
    syncQrEyeInnerCards(page, page.selectedInnerEyeType);

    if (page.errorCorrection) {
        page.errorCorrection.value = selected.errorCorrection;
        page.errorCorrection.dispatchEvent(new Event("change", { bubbles: true }));

        if (window.jQuery) {
            window.jQuery(page.errorCorrection).trigger("change.select2");
        }
    }

    if (page.designMeta) {
        page.designMeta.textContent = selected.label;
    }

    generateQr(page);
}

function parseCsvFirstColumn(csvText) {
    return csvText
        .split(/\r?\n/)
        .map(line => line.trim())
        .filter(Boolean)
        .map(line => {
            const cells = parseCsvLine(line);
            return cells[0]?.trim() || "";
        })
        .filter(Boolean);
}

function parseCsvLine(line) {
    const result = [];
    let current = "";
    let insideQuotes = false;

    for (let i = 0; i < line.length; i++) {
        const char = line[i];
        const next = line[i + 1];

        if (char === '"' && insideQuotes && next === '"') {
            current += '"';
            i++;
            continue;
        }

        if (char === '"') {
            insideQuotes = !insideQuotes;
            continue;
        }

        if (char === "," && !insideQuotes) {
            result.push(current);
            current = "";
            continue;
        }

        current += char;
    }

    result.push(current);
    return result;
}

function applyQrPreset(page, preset) {
    page.presets.forEach(btn => {
        btn.classList.toggle("active", btn.dataset.qrPreset === preset);
    });

    switch (preset) {
        case "classic":
            page.dotStyle.value = "square";
            page.cornerStyle.value = "square";
            page.foreground.value = "#111827";
            page.eyeOuter.value = "#111827";
            page.eyeInner.value = "#111827";
            page.errorCorrection.value = "M";
            break;

        case "rounded":
            page.dotStyle.value = "rounded";
            page.cornerStyle.value = "extra-rounded";
            page.foreground.value = "#111827";
            page.eyeOuter.value = "#111827";
            page.eyeInner.value = "#6366f1";
            page.errorCorrection.value = "Q";
            break;

        case "dots":
            page.dotStyle.value = "dots";
            page.cornerStyle.value = "dot";
            page.foreground.value = "#111827";
            page.eyeOuter.value = "#111827";
            page.eyeInner.value = "#6366f1";
            page.errorCorrection.value = "Q";
            break;

        case "branded":
            page.dotStyle.value = "classy-rounded";
            page.cornerStyle.value = "extra-rounded";
            page.foreground.value = "#111827";
            page.eyeOuter.value = "#6366f1";
            page.eyeInner.value = "#22c55e";
            page.errorCorrection.value = "H";
            break;
    }

    generateQr(page);
}

function setQrMode(page, mode) {
    page.mode = mode;

    page.modeTabs.forEach(tab => {
        tab.classList.toggle("active", tab.dataset.qrModeTab === mode);
    });

    if (page.singleSettings) page.singleSettings.hidden = mode !== "single";
    if (page.bulkSettings) page.bulkSettings.hidden = mode !== "bulk";

    if (mode === "single") {
        generateQr(page);
    }
}

function setQrType(page, type) {
    const selectedType = String(type || "url").trim().toLowerCase();

    page.type = selectedType;

    if (page.typeSelect && page.typeSelect.value !== selectedType) {
        page.typeSelect.value = selectedType;
    }

    if (page.typeSwiper) {
        const realSlides = Array.from(page.typeSwiperEl.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)"));
        const index = realSlides.findIndex(slide => slide.dataset.qrTypeSlide === selectedType);

        if (index >= 0) {
            if (page.typeSwiper.params.loop) {
                page.typeSwiper.slideToLoop(index, 760);
            } else {
                page.typeSwiper.slideTo(index, 760);
            }

            return;
        }
    }

    /*
    page.contentPanels.forEach(panel => {
        const isActive = panel.dataset.qrContentPanel === selectedType;
        panel.hidden = !isActive;
        panel.classList.toggle("active", isActive);
    });*/

    activateQrContentPanel(page, selectedType);
    generateQr(page);
}

function setQrTypeEx(page, type) {
    page.type = type || "url";

    page.typeCards?.forEach(card => {
        card.classList.toggle("active", card.dataset.qrType === page.type);
    });

    if (page.typeSelect && page.typeSelect.value !== page.type) {
        page.typeSelect.value = page.type;

        if (window.jQuery) {
            window.jQuery(page.typeSelect).trigger("change.select2");
        }
    }

    page.contentPanels.forEach(panel => {
        const isActive = panel.dataset.qrContentPanel === page.type;
        panel.hidden = !isActive;
        panel.classList.toggle("active", isActive);
    });

    generateQr(page);
}

function generateQr(page) {
    if (!page.preview) return;

    const data = buildQrData(page);
    if (!data.trim()) {
        setStatus(page, "Empty", "is-error");
        return;
    }

    const options = buildQrOptions(page, data);

    page.preview.innerHTML = "";
    qrInstance = new QRCodeStyling(options);
    qrInstance.append(page.preview);

    updateMeta(page);
    setStatus(page, "Ready", "is-valid");
    updateQrFrame(page);
    updateQrQuality(page);
}

function updateQrQuality(page) {
    if (!page.qualityList || !page.qualityScore) return;

    const warnings = [];

    const fg = page.foreground?.value || "#111827";
    const bg = page.transparent?.checked ? "#ffffff" : (page.background?.value || "#ffffff");
    const contrast = getContrastRatio(fg, bg);

    if (contrast < 4.5 && !page.useGradient?.checked) {
        warnings.push("Foreground and background contrast may be too low.");
    }

    if (page.useGradient?.checked) {
        warnings.push("Gradient QR codes may require testing on print and low-end cameras.");
    }

    if (logoDataUrl && page.errorCorrection?.value !== "H") {
        warnings.push("Use High error correction when adding a logo.");
    }

    const logoSize = Number(page.logoSize?.value || 0.22);
    if (logoDataUrl && logoSize > 0.28) {
        warnings.push("Large logos can reduce scan reliability.");
    }

    const dataLength = buildQrData(page).length;
    if (dataLength > 900) {
        warnings.push("Large QR data may create a dense QR code. Consider shortening the content.");
    }

    if (!warnings.length) {
        page.qualityScore.textContent = "Excellent";
        page.qualityScore.className = "is-good";
        page.qualityList.innerHTML = `<li>No scan reliability issues detected.</li>`;
        return;
    }

    page.qualityScore.textContent = warnings.length > 2 ? "Needs Testing" : "Good";
    page.qualityScore.className = warnings.length > 2 ? "is-warning" : "is-medium";

    page.qualityList.innerHTML = warnings
        .map(x => `<li>${escapeHtml(x)}</li>`)
        .join("");

    if (!warnings.length) {
        page.qualityScore.textContent = "Excellent";
        page.qualityScore.className = "is-good";
        page.qualityList.innerHTML = `<li>No scan reliability issues detected.</li>`;

        if (page.qualityRing) {
            page.qualityRing.innerHTML = `<i class="fa-regular fa-shield-check"></i>`;
            page.qualityRing.className = "qr-quality-panel__ring is-good";
        }

        return;
    }

    const isWarning = warnings.length > 2;

    page.qualityScore.textContent = isWarning ? "Needs Testing" : "Good";
    page.qualityScore.className = isWarning ? "is-warning" : "is-medium";

    if (page.qualityRing) {
        page.qualityRing.innerHTML = isWarning
            ? `<i class="fa-regular fa-triangle-exclamation"></i>`
            : `<i class="fa-regular fa-circle-info"></i>`;

        page.qualityRing.className = isWarning
            ? "qr-quality-panel__ring is-warning"
            : "qr-quality-panel__ring is-medium";
    }
}

function getContrastRatio(hex1, hex2) {
    const l1 = getRelativeLuminance(hexToRgb(hex1));
    const l2 = getRelativeLuminance(hexToRgb(hex2));

    const light = Math.max(l1, l2);
    const dark = Math.min(l1, l2);

    return (light + 0.05) / (dark + 0.05);
}

function hexToRgb(hex) {
    const clean = hex.replace("#", "");
    const full = clean.length === 3
        ? clean.split("").map(x => x + x).join("")
        : clean;

    return {
        r: parseInt(full.slice(0, 2), 16),
        g: parseInt(full.slice(2, 4), 16),
        b: parseInt(full.slice(4, 6), 16)
    };
}

function getRelativeLuminance({ r, g, b }) {
    const values = [r, g, b].map(v => {
        const s = v / 255;
        return s <= 0.03928
            ? s / 12.92
            : Math.pow((s + 0.055) / 1.055, 2.4);
    });

    return values[0] * 0.2126 + values[1] * 0.7152 + values[2] * 0.0722;
}

function updateQrFrame(page) {
    if (page.artboard) {
        page.artboard.classList.toggle("is-frameless", !page.showFrame?.checked);
    }

    if (page.previewLabel) {
        const label = page.qrLabel?.value?.trim() || "";
        page.previewLabel.textContent = label;
        page.previewLabel.hidden = !label || !page.showFrame?.checked;

        page.previewLabel.classList.remove("is-pill", "is-plain", "is-badge");
        page.previewLabel.classList.add(`is-${page.qrLabelStyle?.value || "pill"}`);
    }
}

function normalizeDotStyle(value) {
    const type = String(value || "rounded").toLowerCase();

    const allowed = [
        "square",
        "rounded",
        "dots",
        "extra-rounded",
        "classy",
        "classy-rounded"
    ];

    return allowed.includes(type) ? type : "rounded";
}

function buildQrOptions(page, data) {
    const size = clampNumber(Number(page.size?.value || 512), 128, 2048);
    const foreground = page.foreground?.value || "#111827";
    const background = page.transparent?.checked ? "transparent" : (page.background?.value || "#ffffff");
    const eyeOuter = page.eyeOuter?.value || foreground;
    const eyeInner = page.eyeInner?.value || foreground;
    const dotStyle = normalizeDotStyle(page.selectedDotStyle);
    const cornerStyle = normalizeOuterEyeType(page.selectedOuterEyeType);
    const cornerDotStyle = normalizeInnerEyeType(page.selectedInnerEyeType);
    const errorCorrection = page.errorCorrection?.value || "Q";
    const margin = clampNumber(Number(page.margin?.value || 20), 0, 80);
    const logoMargin = clampNumber(Number(page.logoMargin?.value || 8), 0, 30);
    const hideBackgroundDots = page.hideBackgroundDots?.checked ?? true;

    var options = {
        width: size,
        height: size,
        type: "svg",
        data,
        image: logoDataUrl || undefined,
        margin,
        qrOptions: {
            errorCorrectionLevel: errorCorrection
        },
        dotsOptions: {
            type: dotStyle,
            ...(page.useGradient?.checked
                ? {
                    gradient: {
                        type: page.gradientType?.value || "linear",
                        rotation: ((Number(page.gradientRotation?.value || 45)) * Math.PI) / 180,
                        colorStops: [
                            { offset: 0, color: page.gradientStart?.value || "#6366f1" },
                            { offset: 1, color: page.gradientEnd?.value || "#22c55e" }
                        ]
                    }
                }
                : {
                    color: foreground
                })
        },
        backgroundOptions: {
            color: background
        },
        cornersSquareOptions: {
            type: cornerStyle,
            ...(page.eyeOuterUseGradient?.checked
                ? {
                    gradient: buildGradientOptions(
                        page.eyeOuterGradientType,
                        page.eyeOuterGradientRotation,
                        page.eyeOuterGradientStart,
                        page.eyeOuterGradientEnd
                    )
                }
                : {
                    color: eyeOuter
                })
        },
        cornersDotOptions: {
            type: cornerDotStyle,
            ...(page.eyeInnerUseGradient?.checked
                ? {
                    gradient: buildGradientOptions(
                        page.eyeInnerGradientType,
                        page.eyeInnerGradientRotation,
                        page.eyeInnerGradientStart,
                        page.eyeInnerGradientEnd
                    )
                }
                : {
                    color: eyeInner
                })
        },
        imageOptions: {
            crossOrigin: "anonymous",
            margin: page.logoBackground?.checked ? logoMargin : 0,
            imageSize: clampNumber(Number(page.logoSize?.value || 0.22), 0.08, 0.42),
            hideBackgroundDots
        }
    };

    return options;
}

function buildQrData(page) {
    switch (page.type) {
        case "text":
            return page.text?.value || "";

        case "vcard":
            return buildVCard(page);

        case "wifi":
            return buildWifi(page);

        case "email":
            return buildEmail(page);

        case "phone":
            return `tel:${page.phoneNumber?.value || ""}`;

        case "sms":
            return buildSms(page);

        case "whatsapp":
            return buildWhatsApp(page);

        case "location":
            return buildLocation(page);

        case "event":
            return buildEvent(page);

        case "social":
            return buildSocial(page);

        case "app":
            return buildAppLink(page);

        case "payment":
            return buildPayment(page);

        case "crypto":
            return buildCrypto(page);

        case "file":
            return buildFileLink(page);

        case "menu":
            return buildMenu(page);

        case "contact-lite":
            return buildContactLite(page);

        case "meeting":
            return buildMeeting(page);

        case "url":
        default:
            return page.url?.value || "";
    }
}

function buildWhatsApp(page) {
    const number = normalizePhoneForUrl(page.whatsappNumber?.value || "");
    const message = encodeURIComponent(page.whatsappMessage?.value || "");

    if (!number) return "";

    return message
        ? `https://wa.me/${number}?text=${message}`
        : `https://wa.me/${number}`;
}

function buildLocation(page) {
    const lat = String(page.locationLatitude?.value || "").trim();
    const lng = String(page.locationLongitude?.value || "").trim();
    const label = String(page.locationLabel?.value || "").trim();
    const type = page.locationType?.value || "google";

    if (!lat || !lng) return "";

    if (type === "geo") {
        return label
            ? `geo:${lat},${lng}?q=${lat},${lng}(${encodeURIComponent(label)})`
            : `geo:${lat},${lng}`;
    }

    const query = label
        ? `${lat},${lng} ${label}`
        : `${lat},${lng}`;

    return `https://www.google.com/maps?q=${encodeURIComponent(query)}`;
}

function buildEvent(page) {
    const title = cleanIcs(page.eventTitle?.value || "Event");
    const location = cleanIcs(page.eventLocation?.value || "");
    const description = cleanIcs(page.eventDescription?.value || "");
    const start = toIcsDate(page.eventStart?.value);
    const end = toIcsDate(page.eventEnd?.value);

    if (!start) return "";

    return [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "PRODID:-//Viwo Tools//QR Generator//EN",
        "BEGIN:VEVENT",
        `UID:${Date.now()}@tools.multifonks.com`,
        `DTSTAMP:${toIcsDate(new Date().toISOString())}`,
        `DTSTART:${start}`,
        end ? `DTEND:${end}` : "",
        `SUMMARY:${title}`,
        location ? `LOCATION:${location}` : "",
        description ? `DESCRIPTION:${description}` : "",
        "END:VEVENT",
        "END:VCALENDAR"
    ].filter(Boolean).join("\n");
}

function buildSocial(page) {
    const platform = page.socialPlatform?.value || "instagram";
    const value = String(page.socialValue?.value || "").trim();

    if (!value) return "";

    if (platform === "custom") {
        return ensureUrl(value);
    }

    const username = value
        .replace(/^@/, "")
        .replace(/^https?:\/\/[^/]+\//i, "")
        .trim();

    const urls = {
        instagram: `https://www.instagram.com/${username}`,
        linkedin: username.includes("/in/")
            ? `https://www.linkedin.com/${username}`
            : `https://www.linkedin.com/in/${username}`,
        youtube: username.startsWith("@")
            ? `https://www.youtube.com/${username}`
            : `https://www.youtube.com/@${username}`,
        tiktok: `https://www.tiktok.com/@${username}`,
        x: `https://x.com/${username}`,
        facebook: `https://www.facebook.com/${username}`,
        github: `https://github.com/${username}`
    };

    return urls[platform] || ensureUrl(value);
}

function buildAppLink(page) {
    const fallback = page.appFallbackUrl?.value?.trim();
    const ios = page.appIosUrl?.value?.trim();
    const android = page.appAndroidUrl?.value?.trim();

    return fallback || ios || android || "";
}

function buildPayment(page) {
    const type = page.paymentType?.value || "iban";
    const name = cleanText(page.paymentName?.value || "");
    const iban = cleanText(page.paymentIban?.value || "");
    const bic = cleanText(page.paymentBic?.value || "");
    const amount = cleanText(page.paymentAmount?.value || "");
    const currency = cleanText(page.paymentCurrency?.value || "EUR");
    const description = cleanText(page.paymentDescription?.value || "");
    const link = page.paymentLink?.value?.trim() || "";

    if (type === "paypal" || type === "stripe") {
        return link;
    }

    if (type === "sepa") {
        return buildSepaPayment({
            name,
            iban,
            bic,
            amount,
            currency,
            description
        });
    }

    return [
        "PAYMENT INFO",
        name ? `Name: ${name}` : "",
        iban ? `IBAN: ${iban}` : "",
        amount ? `Amount: ${amount} ${currency}` : "",
        description ? `Description: ${description}` : ""
    ].filter(Boolean).join("\n");
}

function buildCrypto(page) {
    const network = page.cryptoNetwork?.value || "bitcoin";
    const address = String(page.cryptoAddress?.value || "").trim();
    const amount = String(page.cryptoAmount?.value || "").trim();
    const label = String(page.cryptoLabel?.value || "").trim();
    const message = String(page.cryptoMessage?.value || "").trim();

    if (!address) return "";

    if (network === "bitcoin") {
        const params = new URLSearchParams();

        if (amount) params.set("amount", amount);
        if (label) params.set("label", label);
        if (message) params.set("message", message);

        const query = params.toString();
        return query ? `bitcoin:${address}?${query}` : `bitcoin:${address}`;
    }

    if (network === "ethereum") {
        return amount
            ? `ethereum:${address}?value=${encodeURIComponent(amount)}`
            : `ethereum:${address}`;
    }

    if (network === "litecoin") {
        return amount
            ? `litecoin:${address}?amount=${encodeURIComponent(amount)}`
            : `litecoin:${address}`;
    }

    if (network === "dogecoin") {
        return amount
            ? `dogecoin:${address}?amount=${encodeURIComponent(amount)}`
            : `dogecoin:${address}`;
    }

    return address;
}

function buildFileLink(page) {
    return page.fileUrl?.value?.trim() || "";
}

function buildMenu(page) {
    const url = page.menuUrl?.value?.trim() || "";
    const table = page.menuTable?.value?.trim();

    if (!url) return "";

    if (!table) return url;

    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}table=${encodeURIComponent(table)}`;
}

function buildContactLite(page) {
    const name = cleanVCard(page.contactName?.value || "");
    const company = cleanVCard(page.contactCompany?.value || "");
    const phone = cleanVCard(page.contactPhone?.value || "");
    const email = cleanVCard(page.contactEmail?.value || "");
    const website = cleanVCard(page.contactWebsite?.value || "");

    return [
        "BEGIN:VCARD",
        "VERSION:3.0",
        `FN:${name}`,
        company ? `ORG:${company}` : "",
        phone ? `TEL;TYPE=CELL:${phone}` : "",
        email ? `EMAIL:${email}` : "",
        website ? `URL:${website}` : "",
        "END:VCARD"
    ].filter(Boolean).join("\n");
}

function buildMeeting(page) {
    const url = page.meetingUrl?.value?.trim() || "";
    const id = page.meetingId?.value?.trim();
    const password = page.meetingPassword?.value?.trim();

    if (url) return url;

    return [
        "MEETING INFO",
        id ? `Meeting ID: ${id}` : "",
        password ? `Password: ${password}` : ""
    ].filter(Boolean).join("\n");
}

function buildSepaPayment({ name, iban, bic, amount, currency, description }) {
    if (!name || !iban) return "";

    return [
        "BCD",
        "002",
        "1",
        "SCT",
        bic || "",
        name,
        iban.replace(/\s+/g, ""),
        amount ? `${currency}${Number(amount).toFixed(2)}` : "",
        "",
        description || ""
    ].join("\n");
}

function normalizePhoneForUrl(value) {
    return String(value || "")
        .replace(/[^\d+]/g, "")
        .replace(/^\+/, "");
}

function ensureUrl(value) {
    const clean = String(value || "").trim();

    if (!clean) return "";
    if (/^https?:\/\//i.test(clean)) return clean;

    return `https://${clean}`;
}

function cleanText(value = "") {
    return String(value)
        .replaceAll("\n", " ")
        .replaceAll("\r", " ")
        .trim();
}

function cleanIcs(value = "") {
    return String(value)
        .replaceAll("\\", "\\\\")
        .replaceAll("\n", "\\n")
        .replaceAll("\r", "")
        .replaceAll(",", "\\,")
        .replaceAll(";", "\\;")
        .trim();
}

function toIcsDate(value) {
    if (!value) return "";

    const date = value instanceof Date
        ? value
        : new Date(value);

    if (Number.isNaN(date.getTime())) return "";

    return date
        .toISOString()
        .replace(/[-:]/g, "")
        .replace(/\.\d{3}Z$/, "Z");
}

function buildVCard(page) {
    const first = cleanVCard(page.vFirstName?.value);
    const last = cleanVCard(page.vLastName?.value);
    const full = cleanVCard(page.vFullName?.value || `${first} ${last}`.trim());
    const company = cleanVCard(page.vCompany?.value);
    const title = cleanVCard(page.vTitle?.value);
    const phone = cleanVCard(page.vPhone?.value);
    const email = cleanVCard(page.vEmail?.value);
    const website = cleanVCard(page.vWebsite?.value);
    const street = cleanVCard(page.vStreet?.value || page.vAddress?.value);
    const city = cleanVCard(page.vCity?.value);
    const region = cleanVCard(page.vRegion?.value);
    const postal = cleanVCard(page.vPostal?.value);
    const country = cleanVCard(page.vCountry?.value);
    const note = cleanVCard(page.vNote?.value);

    return [
        "BEGIN:VCARD",
        "VERSION:3.0",
        `N:${last};${first};;;`,
        `FN:${full}`,
        company ? `ORG:${company}` : "",
        title ? `TITLE:${title}` : "",
        phone ? `TEL;TYPE=CELL:${phone}` : "",
        email ? `EMAIL:${email}` : "",
        website ? `URL:${website}` : "",
        (street || city || region || postal || country)
            ? `ADR;TYPE=WORK:;;${street};${city};${region};${postal};${country}`
            : "",
        note ? `NOTE:${note}` : "",
        "END:VCARD"
    ].filter(Boolean).join("\n");
}

function buildWifi(page) {
    const ssid = escapeWifi(page.wifiSsid?.value || "");
    const password = escapeWifi(page.wifiPassword?.value || "");
    const encryption = page.wifiEncryption?.value || "WPA";
    const hidden = page.wifiHidden?.checked ? "true" : "false";

    if (encryption === "nopass") {
        return `WIFI:T:nopass;S:${ssid};H:${hidden};;`;
    }

    return `WIFI:T:${encryption};S:${ssid};P:${password};H:${hidden};;`;
}

function buildEmail(page) {
    const address = page.emailAddress?.value || "";
    const subject = encodeURIComponent(page.emailSubject?.value || "");
    const body = encodeURIComponent(page.emailBody?.value || "");

    return `mailto:${address}?subject=${subject}&body=${body}`;
}

function buildSms(page) {
    const number = page.smsNumber?.value || "";
    const message = encodeURIComponent(page.smsMessage?.value || "");
    return `SMSTO:${number}:${message}`;
}

async function downloadCurrentQr(page) {
    if (!qrInstance) generateQr(page);
    if (!qrInstance) return;

    const extension = page.exportFormat?.value || "png";
    const name = normalizeFileName(page.fileName?.value || "viwo-qr-code");

    if (extension === "svg") {
        await downloadOptimizedQrSvg(qrInstance, name, page);
        return;
    }

    await qrInstance.download({
        name,
        extension
    });
}

async function copyCurrentSvg(page) {
    if (!qrInstance) generateQr(page);
    if (!qrInstance) return;

    const blob = await qrInstance.getRawData("svg");
    const text = await blob.text();

    await navigator.clipboard.writeText(text);
    setStatus(page, "SVG copied", "is-valid");
}

async function generateBulk(page) {
    if (!page.bulkInput || !page.bulkGrid || !page.bulkResults) return;

    const lines = page.bulkInput.value
        .split(/\r?\n/)
        .map(x => x.trim())
        .filter(Boolean);

    bulkItems = lines.map((line, index) => ({
        id: index + 1,
        data: line,
        name: `qr-code-${index + 1}`
    }));

    page.bulkGrid.innerHTML = "";
    page.bulkResults.hidden = false;

    for (const item of bulkItems) {
        const card = document.createElement("article");
        card.className = "qr-bulk-card";
        card.innerHTML = `
            <div class="qr-bulk-card__preview" data-bulk-preview="${item.id}"></div>
            <div class="qr-bulk-card__content">
                <strong>${escapeHtml(item.name)}</strong>
                <span>${escapeHtml(item.data)}</span>
            </div>
        `;

        page.bulkGrid.appendChild(card);

        const preview = card.querySelector(`[data-bulk-preview="${item.id}"]`);
        const qr = new QRCodeStyling(buildQrOptions(page, item.data));
        qr.append(preview);
        item.qr = qr;
    }

    if (page.bulkCount) {
        page.bulkCount.textContent = `${bulkItems.length} items`;
    }

    setStatus(page, "Bulk ready", "is-valid");
}

async function downloadBulkZip(page) {
    if (!bulkItems.length) {
        await generateBulk(page);
    }

    if (!bulkItems.length) return;

    const zip = new JSZip();
    const extension = page.exportFormat?.value || "png";

    for (const item of bulkItems) {
        const blob = await item.qr.getRawData(extension);
        zip.file(`${item.name}.${extension}`, blob);
    }

    const zipBlob = await zip.generateAsync({ type: "blob" });
    downloadBlob(zipBlob, "qr-codes.zip");
}

function updateMeta(page) {
    if (page.metaType) page.metaType.textContent = page.type.toUpperCase();
    if (page.metaFormat) page.metaFormat.textContent = (page.exportFormat?.value || "png").toUpperCase();
    if (page.metaSize) page.metaSize.textContent = `${page.size?.value || 512}px`;
}

function setStatus(page, text, stateClass = "") {
    if (!page.status) return;

    page.status.textContent = text;
    page.status.classList.remove("is-valid", "is-error");

    if (stateClass) {
        page.status.classList.add(stateClass);
    }
}

async function readLogoAsDataUrl(file) {
    if (!file) return "";

    return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result || ""));
        reader.onerror = () => resolve("");
        reader.readAsDataURL(file);
    });
}

function loadQrExample(page) {
    setQrMode(page, "single");
    setQrType(page, "vcard");

    if (page.vFirstName) page.vFirstName.value = "Ege";
    if (page.vLastName) page.vLastName.value = "Deniz";
    if (page.vFullName) page.vFullName.value = "Ege Deniz";
    if (page.vCompany) page.vCompany.value = "Viwo Tools";
    if (page.vTitle) page.vTitle.value = "Creative Director";
    if (page.vPhone) page.vPhone.value = "+905551112233";
    if (page.vEmail) page.vEmail.value = "ege@example.com";
    if (page.vWebsite) page.vWebsite.value = "https://tools.multifonks.com";
    if (page.vAddress) page.vAddress.value = "Istanbul, Türkiye";

    generateQr(page);
}

function resetQr(page) {
    logoDataUrl = "";

    if (page.url) page.url.value = "https://tools.multifonks.com";
    if (page.dotStyle) page.dotStyle.value = "rounded";
    if (page.cornerStyle) page.cornerStyle.value = "extra-rounded";
    if (page.size) page.size.value = "512";
    if (page.errorCorrection) page.errorCorrection.value = "Q";
    if (page.foreground) page.foreground.value = "#111827";
    if (page.background) page.background.value = "#ffffff";
    if (page.eyeOuter) page.eyeOuter.value = "#111827";
    if (page.eyeInner) page.eyeInner.value = "#6366f1";
    if (page.transparent) page.transparent.checked = false;
    if (page.logo) page.logo.value = "";
    if (page.logoSize) page.logoSize.value = "0.22";
    if (page.logoBackground) page.logoBackground.checked = true;
    if (page.exportFormat) page.exportFormat.value = "png";
    if (page.fileName) page.fileName.value = "viwo-qr-code";

    setQrMode(page, "single");
    setQrType(page, "url");
    applyQrDesignPreset(page, "rounded");
    generateQr(page);
}

function cleanVCard(value = "") {
    return String(value)
        .replaceAll("\n", " ")
        .replaceAll("\r", " ")
        .replaceAll(";", "\\;")
        .replaceAll(",", "\\,")
        .trim();
}

function escapeWifi(value = "") {
    return String(value)
        .replaceAll("\\", "\\\\")
        .replaceAll(";", "\\;")
        .replaceAll(",", "\\,")
        .replaceAll(":", "\\:")
        .trim();
}

function normalizeFileName(value) {
    return String(value || "qr-code")
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9-_]+/gi, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "") || "qr-code";
}

function downloadBlob(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();

    setTimeout(() => URL.revokeObjectURL(url), 500);
}

function clampNumber(value, min, max) {
    if (Number.isNaN(value)) return min;
    return Math.min(Math.max(value, min), max);
}

function escapeHtml(value) {
    return String(value)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#39;");
}

function debounce(fn, delay = 150) {
    let timer = null;

    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
    };
}